import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const NetworkListAPI = (props) => {
  return axios.get(
    `${env.HOST}/jaringan/${props}`,
    {
      headers
    }
  );
};
export default NetworkListAPI;
